import type { FC } from 'react';
import React from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { PageTreeProps } from '../src/PageTree.tsx';

export const ANIMATE_TIME_SEC = 2;

export const PageTreeLoader: LoadableType<PageTreeProps> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-PageTree" */ '../src/PageTree.tsx')).PageTree,
});

export const PageTree: FC<PageTreeProps> = (props) => {
	return <PageTreeLoader {...props} />;
};
